import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const solRoutes: Routes = [
  {
    path: 'solicitacao',
    loadChildren: () =>
      import('../pages/sol/solicitacao/solicitacao.module').then(
        (module) => module.SolicitacaoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cadastro-generico",
    loadChildren: () =>
      import("../pages/cad/cadastro-generico/cadastro-generico.module").then(
        (module) => module.CadastroGenericoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "solicitacao-tipo-vinculo",
    loadChildren: () =>
      import("../pages/sol/solicitacao-tipo-vinculo/solicitacao-tipo-vinculo.module").then(
        (module) => module.SolicitacaoTipoVinculoModule
      ),
    canActivate: [AuthGuard],
  }
];
